import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";

const StockItemModal = ({ showModal, closeModal, branch, itemCode, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // Function to fetch indent records
  const fetchData = async () => {
    if (!branch || !itemCode) return;
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stockSummary_item", {
        params: { branch, code: itemCode },
      });
      setSearchResults(response.data.results || []);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (showModal) {
      fetchData();
    }
  }, [showModal, branch, itemCode]);

  // Debounce search
  useEffect(() => {
    if (!showModal) return;
    const delaySearch = setTimeout(fetchData, 500);
    return () => clearTimeout(delaySearch);
  }, [searchTerm]);

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Item Details</h3>

        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          <div className="search-results">
            <table>
              <thead>
                <tr>
                  <th>Item Tree</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.length > 0 ? (
                  searchResults.map((item) => (
                    <tr key={item.code}>
                      <td>{item.code} - {item.itemName}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="no-results">No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default StockItemModal;
